import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const kejianrouter = [
  {
    path: "/",
    name: "home",
    component: () => import("./views/Home.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("./views/News.vue"),
  },
  {
    path: "/YaoPin",
    name: "YaoPin",
    component: () => import("./views/YaoPin/index.vue"),
  },
  {
    path: "/YaoPinDetails/:id",
    name: "YaoPinDetails",
    component: () => import("./views/YaoPin/Details.vue"),
  },
  {
    path: "/Qixie",
    name: "Qixie",
    component: () => import("./views/Qixie/index.vue"),
  },
  {
    path: "/QixieDetails/:id",
    name: "QixieDetails",
    component: () => import("./views/Qixie/Details.vue"),
  },
  {
    path: "/newsdetails/:id",
    name: "newsdetails",
    component: () => import("./views/NewsDetails.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () => import("./views/Product.vue"),
  },
  {
    path: "/case",
    name: "case",
    component: () => import("./views/Case.vue"),
  },
  {
    path: "/casedetails/:id",
    name: "casedetails",
    component: () => import("./views/CaseDetails.vue"),
  },
  {
    path: "/goin",
    name: "goin",
    component: () => import("./views/GoIn.vue"),
  },
  {
    path: "/download",
    name: "download",
    component: () => import("./views/Download.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/Login.vue"),
  },
  {
    path: "/application", //应用
    name: "application",
    component: () => import("./views/product/application.vue"),
  },
  {
    path: "/hardware", //硬件
    name: "hardware",
    component: () => import("./views/product/hardware.vue"),
  },
  {
    path: "/platform", //平台
    name: "platform",
    component: () => import("./views/product/platform.vue"),
  },
  {
    path: "/communityServiceCenter", //社区服务中心
    name: "platform",
    component: () => import("./views/product/communityServiceCenter.vue"),
  },
  {
    path: "/systemUse", //系统试用联系
    name: "systemUse",
    component: () => import("./views/contactUs/systemUse.vue"),
  },
  {
    path: "/solution", //解决方案
    name: "solution",
    component: () => import("./views/solution.vue"),
  },
  {
    path: "/price", //价格
    name: "price",
    component: () => import("./views/price.vue"),
  },
  {
    path: "/serve", //服务
    name: "serve",
    component: () => import("./views/serve.vue"),
  },
  {
    path: "/companyIntroduction", //公司介绍
    name: "companyIntroduction",
    component: () => import("./views/AboutUs/companyIntroduction.vue"),
  },
  {
    path: "/serviceAgreement", //服务协议
    name: "serviceAgreement",
    component: () => import("./views/AboutUs/serviceAgreement.vue"),
  },
  {
    path: "/joinUs", //加入我们
    name: "joinUs",
    component: () => import("./views/AboutUs/joinUs.vue"),
  },
  {
    path: "/contactUs", //联系我们
    name: "contactUs",
    component: () => import("./views/AboutUs/contactUs.vue"),
  },
  {
    path: "/information", //养老资讯
    name: "information",
    component: () => import("./views/AboutUs/information.vue"),
  },
];
export default new Router({
  routes: kejianrouter,
});
